
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/investor",
      function () {
        return require("private-next-pages/investor/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/investor"])
      });
    }
  